import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import { getBasicBiDataForDuperItem } from '../../../Duperbrowse/redux/helpers';
import { getCurrentItem } from '../../../Duperbrowse/redux/selectors';
import s from './BackToStashButton.scss';
const BackToStreamButton = ({ className, folder })=>{
    const currentItem = useSelector(getCurrentItem);
    const openStash = useCallback(()=>{
        if (folder && folder.folderId) {
            window.location.assign(Url.stashFolderLink(folder.folderId));
        }
    }, [
        folder
    ]);
    if (!folder || !folder.folderId) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(TextButton, {
        icon: ArrowLeft,
        variant: "main",
        size: "small",
        className: classnames(s['duperexit'], className),
        onClick: openStash,
        noHorizontalPaddings: false,
        biData: currentItem && BiData(_object_spread({
            evid: 304
        }, getBasicBiDataForDuperItem(currentItem)))
    }, "Back to ", folder.name);
};
BackToStreamButton.displayName = 'BackToStreamButton';
export default BackToStreamButton;
